import { BaseRepository } from "@/repositories/base-repository"
import { type IRentalIntakeItem } from "@/interfaces/api/rental-intake-item.interface"

export class RentalIntakeItemRepository extends BaseRepository<IRentalIntakeItem> {
  protected resourcePath = "administration/rental-intake-items"
}
